<template>
	<div id="novel_list">
		<div class="novel_list_top">
			<div class="novel_list">
				<div class="flex-row">
					<div class="novel_list1 cursor_1">
						<!-- <img src="../assets/image/icon_right.png" alt=""> -->
						作品回收站
					</div>
					<div class="t-m-l-20">
						<el-button type="text" class="novel_list2 " v-if="novelList.length > 0">
							<span @click="openEditor" v-if="isEdit">管理</span>
							<span @click="openEditor" v-if="!isEdit">取消</span>
						</el-button>
					</div>
					<div class="t-m-l-20">
						<el-button type="text" class="novel_list2 " v-if="novelList.length > 0">
							<span @click="clearNovel">清空回收站</span>
						</el-button>
					</div>
				</div>
				<div class="flex-row" :class="!isEdit ? 'noEditor_pointer' : ''">
					<!-- <el-select class="search_select" v-model="status" clearable placeholder="连载状态" style="width:150px;"
					@change="statusSelectChange">
					<el-option label="选择连载状态" value=""></el-option>
					<el-option label="连载" value="0"></el-option>
					<el-option label="完结" value="1"></el-option>
				</el-select>
				<el-select class="search_select t-m-l-15" v-model="length" clearable placeholder=""
					style="width: 150px;" @change="statusSelectChange">
					<el-option label="选择篇幅设定" value=''></el-option>
					<el-option label="长篇" value="长篇"></el-option>
					<el-option label="中篇" value="中长篇小说"></el-option>
					<el-option label="短篇" value="短篇小说"></el-option>
				</el-select> -->
					<!-- <el-select class="search_select t-m-l-15" v-model="collect" clearable placeholder="是否收藏"
					style="width: 120px;" @change="statusSelectChange">
					<el-option label="是否收藏"   value=''></el-option>
					<el-option label="已收藏" :value=true></el-option>
					<el-option label="未收藏" :value=false></el-option>
				</el-select> -->

					<!-- <el-input placeholder="请输入作品名称" v-model="query" class="novel_input-with-select t-m-l-15 t-m-r-20"
					@keyup.enter.native="selectClick" @input="blurClick">
					<i class="el-icon-search el-input__icon cursor_1" :style="{ pointerEvents: !isEdit ? 'none' : '' }"
						slot="suffix" @click="selectClick">
					</i>
				</el-input> -->

				</div>

			</div>
			<div class="novel_list3" v-if="novelList.length == 0">
				<!-- <noData :noIndex="1" @toCreate="toCreate" v-if="!query"></noData> -->
				<el-empty description="未搜索到相关作品"></el-empty>
			</div>
			<div class="novel_list3" v-else>
				<div v-if="!isEdit" class="selectBtn">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
						@change="handleCheckAllChange">全选</el-checkbox>
					<el-button type="text" @click="batchDel" style="margin-left: 20px;">删除</el-button>
				</div>
				<div class="item">
					<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" value-key="id">
						<div class="novel_list4" v-for="(item, i) in novelList" :key="i">
							<el-checkbox :label="item" v-if="!isEdit" class="no-label"></el-checkbox>
							<div
								style="position: relative;width: 100px;height: 133px;flex-shrink: 0;border-radius: 8px;">
								<img class="novel_list5" style="object-fit: cover;" :src="item.img" alt="">
								<span class="length_text zhong"
									v-if="item.length && item.length.includes('中')">中篇</span>
								<span class="length_text duan"
									v-else-if="item.length && item.length.includes('短')">短篇</span>
								<span class="length_text long"
									v-else-if="item.length && item.length.includes('长')">长篇</span>
							</div>

							<div class="novel_list6">
								<div class="novel_list7">{{ item.name }}</div>
								<div class="novel_list8">
									<span style="margin-right: 10px;">{{ item.status == 0 ? '连载中' : '已完结' }} {{
										item.totalNumber }}</span>
								</div>
								<div class="novel_list8">{{ item.chapters }}</div>
								<div class="novel_list9">
									<div class="novel_list10">{{ item.lastUpdate }}<span
											class="t-m-l-20 novel_time_text" v-if="item.lastUpdateTime">{{
												item.lastUpdateTime
											}}更新</span></div>
									<div class="novel_list11">
										<!-- <div class="novel_list12 cursor_1" v-for="(items, l) in novelListIcon" :key="l"
										@click.stop="nextStep(i, l)">
										<img :src="items.icon" class="hover-img" alt="">
										<img :src="items.unicon" class="normal-img" alt="">
										<span>{{ items.name }}</span>
									</div> -->
										<template v-for="(items, l) in novelListIcon">
											<el-tooltip popper-class="novel_toolTip"
												:disabled="Object.hasOwn(items, 'title') ? false : true" :key="l"
												placement="top" effect="light" :content="tooltipName(item, items)">
												<div class="novel_list12 cursor_1 btn_item" @click.stop="nextStep(i, l)"
													@mouseenter="() => { selectedIndex = l; selectedId = item.id }"
													@mouseleave="() => { selectedIndex = -1; selectedId = '' }">
													<img class="t-m-r-5"
														:src="selectedIndex === l && selectedId == item.id ? items.icon : items.uIcon"
														alt="">
													<span>{{ items.name }}</span>
												</div>
											</el-tooltip>
										</template>
									</div>
								</div>
							</div>
						</div>
					</el-checkbox-group>
				</div>
			</div>
		</div>
		<bottomPage v-show="total" :total="total" @currentNUm="currentNUm" :pageNum.sync="pageNum"
			:pageSize.sync="pageSize" ref="bottompage"></bottomPage>
		<delPopup ref="delPopup" @confirm="confirmDel"></delPopup>
		<LengthSettingPopup ref="lengthSetting" @curClick="curClick"></LengthSettingPopup>
	</div>
</template>

<script>
import data from '@/assets/data';
import noData from './no_data.vue';
import delPopup from './del_popup.vue';
import LengthSettingPopup from '@/components/long_novel/LengthSettingPopup.vue';
import bottomPage from '../components/bottom_page.vue' //底部分页
import api from '@/api/api';
import RApi from '@/api/recycle'
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		noData, delPopup, LengthSettingPopup, bottomPage
	},
	data() {
		return {
			novelListIcon: data.scriptListIcon1,//作品编辑
			collectIcon: data.collectIcon,//收藏图标
			delId: null, //删除id
			query: '',//搜索关键字
			status: '',// 空是全部，连载状态(0连载中 1已完结)
			collect: false,//是否收藏
			delFlag: true,
			pageNum: 1,
			pageSize: 10,
			length: '',//篇幅设定
			isEdit: true,//默认true不编辑，true编辑
			checkAll: false,
			checkedCount: 0,//选中状态
			checkedCities: [],
			isIndeterminate: false,
			novelList: [],//列表
			total: 0,
		}
	},
	created() {
		// let cache = JSON.parse(localStorage.getItem(this.rSearchKey))
		// console.log('获取本地缓存33=', cache)
		// Object.assign(this.$data, cache)
		this.init()
	},
	mounted() {
		// if (this.$refs.bottompage) {
		// 	setTimeout(() => {
		// 		this.$refs.bottompage.page(this.pageNum)
		// 	}, 200);
		// }
	},
	methods: {
		init() {
			this.selectClick()
		},
		//搜索
		selectClick() {
			let data = {
				query: this.query,
				status: this.status,
				length: this.length,
				delFlag: this.delFlag,
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			console.log('如果是超过第一页的数据就要额外进行分析了')
			api.getNewNovellist({ ...data, pageNum: 1 }).then(result => {
				//先去请求总数，去计算是在当前页还是上一页
				let total = result.total
				const maxPage = Math.ceil(total / this.pageSize)
				this.pageNum = Math.min(this.pageNum, maxPage ? maxPage : 1)
				data.pageNum = this.pageNum
				localStorage.setItem(this.rSearchKey, JSON.stringify(data))
				api.getNewNovellist(data).then(res => {
					if (res.code === 200) {
						this.total = res.total
						this.novelList = res.rows
					}
				})
			})
		},
		tooltipName(item, items) {
			let name = ''
			if (items.name === '编辑') {
				name = item.length.startsWith("长篇") ? '编辑分卷' : '编辑大纲'
			}
			else if (items.name === '管理') {
				name = item.length.startsWith("长篇") ? '分卷管理' : '章节管理'
			}
			else if (items.name === '置顶') {
				name = item.top > 0 ? '已置顶' : '置顶'
			} else {
				name = items.title
			}
			return name
		},
		//失去焦点触发
		blurClick() {
			if (!this.query.trim()) {
				this.selectClick(true)
			}
		},
		statusSelectChange(e) {
			this.selectClick(true)
		},
		lengthSelectChange(e) {
			this.selectClick(true)
		},
		//状态选择
		statusChang(e) {
			console.log('状态值选中=', e)
			this.selectClick(true)
		},
		lengthChang() {
			this.selectClick(true)
		},
		toHome() {
			this.$router.push({ path: '/' });
		},
		//去创作
		toCreate(type, novelId = '') {
			this.$refs.lengthSetting.open(type, novelId)
			// this.$emit('toCreate')
		},
		//小说的行为，去新建还是克隆，还是编辑
		curClick(params) {
			if (params.item.length.includes('中') || params.item.length.includes('短')) {
				params.item.length = params.item.length.includes('中') ? '中长篇小说' : '短篇小说'
				this.$emit('toCreate', params.item)
			} else {
				if (params.type === 'add') {
					this.$router.push('/longNovel');
				}
			}
		},
		//清理回收站
		clearNovel() {
			this.$confirm('清空回收站作品不可恢复，确定清空?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				RApi.clearNovleRecycle().then(res => {
					if (res.code === 200) {
						this.$message.success('清理完成！')
						this.initData()
						this.init()
					} else {
						this.$message.warning(res.msg)
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消清空'
				});
			});
		},
		//批量删除
		batchDel() {
			if (!this.checkedCities.length) {
				this.$message.warning('请选择要删除的作品')
				return
			}
			this.$refs.delPopup.openPrompt(0, true)
		},
		//0作品置顶 1章节管理 2查看大纲 3作品信息 4作品下载 5作品克隆 6作品删除
		nextStep(i, l) {
			//恢复
			if (l == 0) {

				this.$confirm('需要恢复该作品吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let type = this.novelList[i].ltype === 'lnovel' ? 'lnovel' : 'novel'
					api.novelRestore({ novelId: this.novelList[i].id, type }).then(res => {
						if (res.code === 200) {
							this.$message.success('恢复成功！')
							this.init()
						} else {
							this.$message.warning(res.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消恢复'
					});
				});
			}
			//删除
			if (l == 1) {
				this.$confirm('删除后将无法恢复，请谨慎操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delId = this.novelList[i]
					lNApi.longNovelDel({ id: this.novelList[i].id }).then((res) => {
						if (res.code == 200) {
							this.$message.success('删除成功！')
							// this.novelList.splice(i, 1)
							this.init()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				return
			}
		},
		saveTextToFile(text, novel) {
			const now = new Date();
			const timestamp = now.toISOString().replace(/[:.]/g, '-');
			const fileName = `${novel.name}_${timestamp}.txt`;
			const element = document.createElement('a');
			const file = new Blob([text], { type: 'text/plain' });
			element.href = URL.createObjectURL(file);
			element.download = fileName;
			element.click();
			URL.revokeObjectURL(element.href);
			return {
				fileName,
				downloadTime: now.toISOString(),
			};
		},
		saveToLocalStorage(downloadInfo) {
			let novelDownload = JSON.parse(localStorage.getItem('novelDownload')) || [];
			novelDownload.push(downloadInfo);
			localStorage.setItem('novelDownload', JSON.stringify(novelDownload));
		},
		//数据初始化
		initData() {
			this.isEdit = true
			this.checkedCities = []
			this.checkAll = false
			this.indeterminate = false
			this.checkedCount = 0
		},
		//确认删除
		confirmDel(isAllDel) {
			if (isAllDel) {
				console.log('进入这里来了=', this.checkedCities)
				RApi.novleRecycleDel(this.checkedCities).then((res) => {
					if (res.code == 200) {
						this.$message.success('删除成功！')
						this.initData()
						this.init()
					}
				})
			}

		},
		openEditor() {
			this.isEdit = !this.isEdit
			//如果取消，就取消勾选
			if (this.isEdit) {
				this.initData()
			}
		},
		handleCheckAllChange(val) {
			this.checkedCities = val ? this.novelList : [];
			this.isIndeterminate = false;
			console.log('全选事件=', this.checkedCities)
		},
		handleCheckedCitiesChange(value) {
			console.log('选中事件=', value)
			this.checkedCount = value.length;
			this.checkAll = this.checkedCount === this.novelList.length;
			this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.novelList.length;
		},
		//分页下一页
		currentNUm(pageNum) {
			this.pageNum = pageNum
			//分页记录缓存
			this.init()
		},
	}
}
</script>

<style lang="scss" scoped>
/*  */
.novel_input-with-select {
	width: 300px;
	background-color: #FFFFFF !important;

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.search_select {

	::v-deep(.el-input__inner) {
		width: 100% !important;
		background-color: #FFFFFF !important;

		&::placeholder {
			color: #aaa;
		}
	}
}

.novel_input-with-select .el-icon-search {
	font-size: 120% !important;
}

.novel_input-with-select>.el-input__inner {
	background-color: #FFFFFF !important;
	width: 300px !important;
}

#novel_list {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

}

.novel_list_top {
	border-radius: 10px;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #FFFFFF;
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	overflow: auto;
	margin-bottom: 15px;
}

.novel_list {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #E6EBF0;
	padding: 0 25px;
}

.novel_list1 {
	font-weight: bold;
	font-size: 19px;
	color: #111111;
	display: flex;
	align-items: center;
	flex-shrink: 0;
}

.novel_list1 img {
	width: 23px;
	height: 23px;
	margin-right: 5px;
}

.no-label {
	padding-right: 20px !important;

	::v-deep .el-checkbox__label {
		display: none !important;
	}
}



/* .novel_list2 {
	width: 110px;
	height: 21px;
	background: url('../assets/image/icon_list.png') no-repeat;
	background-size: 21px 21px;
	background-position: left center;
	padding-left: 25px;
	font-size: 17px;
	color: var(--tech-primary);
	line-height: 21px;
} */

.novel_list2 {
	height: 40px;

	span {
		font-size: 17px;
	}
}

/* .novel_list2:hover {
	background: url('../assets/image/icon_list1.png') no-repeat;
	background-size: 21px 21px;
	color: var(--tech-primary);
} */

.novel_list3 {
	flex: 1;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
}

.novel_list3 .selectBtn {
	flex-shrink: 0;
	height: 50px;
	line-height: 50px;
	padding: 0 25px;
}

.novel_list3 .item {
	flex: 1;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.novel_list4 {
	display: flex;
	margin: 0 25px;
	padding: 21px 0;
	border-bottom: 1px solid #E6EBF0;
}

.novel_list5 {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 8px;
	flex-shrink: 0;
}

.length_text {
	position: absolute;
	display: block;
	font-size: 15px;
	text-align: center;
	top: 0;
	left: 0;
	width: 40px;
	/* 长方形的宽度 */
	height: 24px;
	/* 形状颜色 */
	border-top-left-radius: 6px;
	/* 左上角与父 div 圆角一致 */
	border-bottom-right-radius: 12px;
	/* 右侧弧度 */

	&.long {
		background: #FF6603;
		color: #fff;
	}

	&.duan {
		background: #00CF9B;
		color: #fff;
	}

	&.zhong {
		background: #548AFF;
		color: #fff;
	}
}

.novel_list6 {
	flex: 1;
	height: 133px;
	margin-left: 10px;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list7 {
	font-weight: bold;
	font-size: 18px;
	color: #111111;
}

.novel_list8 {
	font-size: 16px;
	color: #333333;
}

.novel_list9 {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.novel_time_text {
	color: var(--tech-primary);
}

.novel_list10 {
	font-size: 14px;
	color: #666666;
}

.novel_list11 {
	display: flex;
}

.novel_list12 {
	display: flex;
	align-items: center;
	font-size: 15px;
	color: #333333;
	padding-left: 15px;
	position: relative;
}

.novel_list12:hover {
	color: var(--tech-primary);

	.normal-img {
		opacity: 0;
	}

	.hover-img {
		opacity: 1;
	}
}

.novel_list12 img {
	width: 16px;
	height: 16px;
	line-height: 1;
	display: flex;
	align-items: center;
	position: absolute;
	left: -5px;
	transition: opacity 0s ease;
}

.hover-img {
	opacity: 0;
}
</style>